

function ContentWrapper({ children }) {
  return <div>{children}</div>
}

export default ContentWrapper
